import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { post } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';
import { PublishEstimates } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner';

const config = [{ actionType: 'publish', apiPath: `${apiWeeklyPlanner}/publish`, method: post }];

export const { publish } = createThunks(typePrefix, config);

export const publishApi = createApi({
  reducerPath: 'weeklyPlannerPublishApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['publishEstimates'],
  endpoints: (builder) => ({
    getPublishEstimates: builder.query<PublishEstimates, { published_date: string }>({
      query: (params) => ({ url: '/publish/estimates', method: 'GET', params }),
      providesTags: (_res, _err, arg) => [
        { type: 'publishEstimates', id: 'LIST' },
        { type: 'publishEstimates', id: arg.published_date },
      ],
      transformResponse: (payload) => unwrap<PublishEstimates>(payload),
    }),
  }),
});

export const { useGetPublishEstimatesQuery } = publishApi;
export const invalidatePublishEstimates = () =>
  publishApi.util.invalidateTags([{ type: 'publishEstimates', id: 'LIST' }]);
